<button
    *ngIf="visible"
    mat-raised-button
    [color]="color"
    [type]="type"
    [disabled]="disabled"
    (click)="onClick()"
    elightFixedDimensions
    class="d-flex align-items-center justify-content-center"
    [ngClass]="{
        'mat-raised-button': !mdType || mdType === 'raised',
        'mat-flat-button': mdType === 'flat',
        'mat-button': mdType == 'basic',
        'mat-stroked-button': mdType == 'stroked',
        'mat-icon-button': mdType == 'icon',
        'mat-fab': mdType == 'fab',
        'mat-mini-fab': mdType == 'mini-fab'
    }"
>
    <ng-container *ngIf="!inProgress">
        <ng-content></ng-content>
    </ng-container>
    <mat-spinner
        [diameter]="diameter"
        *ngIf="inProgress"
        [ngClass]="{
            white:
                color === 'primary' &&
                (!mdType || mdType === 'flat' || mdType === 'raised')
        }"
    ></mat-spinner>
</button>
